import React from 'react';

import { Icon } from '@chakra-ui/react';

export const MetadataIcon = props => (
  <Icon viewBox="0 0 256 256" color="inherit" w="full" h="full" {...props}>
    <path d="M212,48V88a4,4,0,0,1-8,0V52H168a4,4,0,0,1,0-8h40A4.0002,4.0002,0,0,1,212,48ZM88,204H52V168a4,4,0,0,0-8,0v40a4.0002,4.0002,0,0,0,4,4H88a4,4,0,0,0,0-8Zm120-40a4.0002,4.0002,0,0,0-4,4v36H168a4,4,0,0,0,0,8h40a4.0002,4.0002,0,0,0,4-4V168A4.0002,4.0002,0,0,0,208,164ZM88,44H48a4.0002,4.0002,0,0,0-4,4V88a4,4,0,0,0,8,0V52H88a4,4,0,0,0,0-8Z" />
  </Icon>
);
